import React from "react";
import styles from "../PreviewV3.module.css";

export default function HighRiskActivities({ sectionData, displayName, sectionNumber, targetId }) {
  const safeSectionData = Array.isArray(sectionData) ? sectionData : [];

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewHRAGrid}>
          {safeSectionData.map((category, index) => (
            <HighRiskCategoryCard key={index} category={category} />
          ))}
        </div>
      </div>
    </div>
  )
}

const HighRiskCategoryCard = ({ category }) => {
  const safeCategory = category || {};
  const activities = Array.isArray(safeCategory.activities) ? safeCategory.activities : [];

  return (
    <div className={styles.PreviewHRACol}>
      <div className={styles.PreviewHRAColHeading} style={{ backgroundColor: safeCategory.category_color || "#fff", color: "#000" }}>
        {safeCategory.category_name}
      </div>
      <ul className={styles.PreviewHRAColList}>
        {activities.map((activity, index) => (
          <li key={index} className={styles.PreviewHRAColListItem}>
            {(activity && activity.selected) && activity.selected === 1 ? (
              <svg width="14" height="14" viewBox="0 0 16 16" className={styles.PreviewMethodItemCheckbox}>
                <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3" fill="#10B981" stroke="#10B981"></rect>
                <path d="M4 8.3 L7 11 L12 4.8" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>) : (
              <svg width="14" height="14" viewBox="0 0 16 16" className={styles.PreviewMethodItemCheckbox}>
                <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3" fill="#fff" stroke="#CBD5E1" strokeWidth="1.2"></rect>
              </svg>
            )}
            <span>{activity && activity.activity_name}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}